import { useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { useAuth } from "../../auth/components/AuthInit";
import { Modal } from "../../common/Modal";
import { ShareAccountDialog } from "../../common/ShareAccountDialog";
import * as actions from "../redux/AgentAction";
import { CreateAgentForm } from "./CreateAgentForm";

export const CreateAgentDialog = ({
  setSwalProps,
  pageParams = { agentpagenum: "0", memberpagenum: "0" },
}) => {
  const intl = useIntl();
  const formikRef = useRef();
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const shareTriggerRef = useRef();
  const { auth, saveAuth } = useAuth();
  const agentState = useSelector(({ agent }) => agent, shallowEqual);
  const [shareAccount, setShareAccount] = useState(null);

  const saveValues = (queryParams) => {
    dispatch(actions.createAgentList(queryParams)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        formikRef.current.resetForm();
        dismissBtnRef.current.click();
        const reloadParams = {
          action: "agentmemberlist",
          selagentid: auth.selagentid ?? auth.agentid,
          ...pageParams,
        };
        dispatch(actions.callAgentList(reloadParams));

        if (resp.shareAgentAccount) {
          setShareAccount(resp.shareAgentAccount);
          setTimeout(() => shareTriggerRef.current?.click(), 400);
        } else {
          setSwalProps({
            show: true,
            icon: "success",
            title: intl.formatMessage({ id: "success" }),
            text: intl.formatMessage({ id: "createAgentSuccess" }),
          });
        }
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="addAgentModal"
        title={intl.formatMessage({ id: "createAgent" })}
        dismissBtnRef={dismissBtnRef}
      >
        <div className="p-3 custom-border-bottom">
          <CreateAgentForm formikRef={formikRef} saveValues={saveValues} />
        </div>
        <div className="p-3 d-flex justify-content-end align-items-center">
          {agentState.actionsLoading && (
            <div
              className="spinner-border me-2"
              role="status"
              style={{ scale: "0.55" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
          <button
            type="button"
            disabled={agentState.actionsLoading}
            className="btn btn-primary px-3"
            onClick={() => formikRef.current.submitForm()}
          >
            {intl.formatMessage({ id: "create" })}
          </button>
        </div>
      </Modal>
      <button
        ref={shareTriggerRef}
        type="button"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#shareAgentAccountModal"
      />
      <ShareAccountDialog
        modalId="shareAgentAccountModal"
        data={shareAccount}
      />
    </div>
  );
};
